// extracted by mini-css-extract-plugin
export default {"loaderCont":"loader_loaderCont__vUuYC","loaderIcon":"loader_loaderIcon__XauUN","spin":"loader_spin__jJu-m"};